import { GeographyProps, ProjectionConfig } from 'react-simple-maps';

export const projectionConfig: ProjectionConfig = {
    rotate: [-105, 0, 0],
    parallels: [52, 64],
};

export const geographyStyles: GeographyProps['style'] = {
    default: {
        outline: 'none',
        stroke: 'rgba(255,255,255, 0.2)',
        transition: 'opacity .2s ease-in-out',
    },
    pressed: {
        opacity: 0.6,
        outline: 'none',
    },
    hover: {
        opacity: 0.8,
        outline: 'none',
    },
};
